module.exports = __webpack_public_path__ + "img/completed.415b195d.svg";